export class Credentials {
  static credentialsKey = 'credentials'
}
